.scrollContainer {
    display: block;
    overflow: auto hidden;
    scroll-snap-type: x mandatory;
}

.slidesWrapper {
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
}

.slide {
    display: inline-block;
    scroll-snap-align: start;
    white-space: normal;
}

.controls {
    display: flex;
    z-index: 1;
    gap: var(--spacer-8);

    &.hidden {
        display: none;
    }
}

.navArrow {
    svg {
        display: block;
        width: var(--spacer-40);
        height: var(--spacer-40);
        fill: var(--color-contrast);
    }

    &.previous svg {
        transform: scaleX(-1);
    }
}
